<snelstart-ui-button type="secondary"
                     class="custom-input-150"
                     icon="magnifying-glass"
                     (click)="this.showDialog()">Specificatie
</snelstart-ui-button>

<snelstart-ui-dialog-definition id="lg" title="Specificatie beginvermogen" size="lg"
                                [(visible)]="dialogVisible">
    <snelstart-ui-dialog-body>

        <form [formGroup]="eigenVermogenFg">
            <div>
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog ">
                        <p>Eigen vermogen</p>
                    </div>
                    <div>
                        <snelstart-ui-number-form-control formControlName="eigenVermogenBeginstand"
                                                          id="eigenVermogenBeginstand"
                                                          class="custom-input-150"
                                                          [decimals]="0"
                                                          align="right"
                                                          prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                </div>
            </div>
        </form>

        <form [formGroup]="rapportFormGroup">
            <ng-container formGroupName="specificatieWuo">
                <ng-container formGroupName="opbouw">

                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Kostenegalisatiereserve</p>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="beginstandKER"
                                                                  id="beginstandKER"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Herinvesteringsreserve</p>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="beginstandHIR"
                                                                  id="beginstandHIR"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Fiscale oudedagsreserve</p>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="beginstandFOR"
                                                                  id="beginstandFOR"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="flex-container-dialog">
                            <div class="flex-item-tekst-dialog ">
                                <p>Totaal beginvermogen</p>
                            </div>
                            <div class="flex-item-ruimte-dialog"></div>
                            <div>
                                <snelstart-ui-number-form-control formControlName="totaleBeginvermogen"
                                                                  id="totaleBeginvermogen"
                                                                  class="custom-input-150"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </form>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button id="cancel" class="me-2" type="secondary" btn-x>Annuleren</snelstart-ui-button>
        <snelstart-ui-button id="save" type="primary" icon="check">Akkoord</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
